import { render, staticRenderFns } from "./LangBtn.vue?vue&type=template&id=3ebba9a9&scoped=true&"
import script from "./LangBtn.vue?vue&type=script&lang=js&"
export * from "./LangBtn.vue?vue&type=script&lang=js&"
import style0 from "./LangBtn.vue?vue&type=style&index=0&id=3ebba9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebba9a9",
  null
  
)

export default component.exports